import { EntitiesState } from '@redux/entities'

import type { CampaignQuoteTemplateItemModel } from '@models/types'

type BuildBundleOrderParams = {
  campaignId: number,
  campaignQuoteId?: number,
  campaignQuoteTemplateId?: number,
  orderBundleId: number,
  orderBundles: EntitiesState['orderBundles'],
  quoteSectionId?: number,
  redirect?: string,
}

const buildBundleOrder = (params: BuildBundleOrderParams) => {
  const {
    campaignId,
    campaignQuoteId,
    campaignQuoteTemplateId,
    orderBundleId,
    orderBundles,
    quoteSectionId,
    redirect,
  } = params

  const orderBundle = orderBundles[orderBundleId]

  // Quote Item
  if (campaignQuoteId || campaignQuoteTemplateId){
    const payload: CampaignQuoteTemplateItemModel = {
      // @ts-expect-error TS2353
      campaign_quote_id: undefined,
      campaign_quote_section_id: undefined,
      campaign_quote_template_id: undefined,
      campaign_quote_template_section_id: undefined,
      order_bundle_id: orderBundle.id,
      item_type: 'orderable',
      title: orderBundle.title,
    }

    // Quote
    if (campaignQuoteId){
      // @ts-expect-error TS2339
      payload.campaign_quote_id = campaignQuoteId
      // @ts-expect-error TS2339
      payload.campaign_quote_section_id = quoteSectionId
    }

    // Quote Template
    if (campaignQuoteTemplateId){
      payload.campaign_quote_template_id = campaignQuoteTemplateId
      payload.campaign_quote_template_section_id = quoteSectionId
    }

    return {
      itemType: campaignQuoteTemplateId ? 'quoteTemplateItem' : 'quoteItem',
      payload,
      redirect,
    }
  }

  // Order
  return {
    itemType: 'order',
    payload: {
      campaign_id: campaignId,
      order_type: 'bundle',
      item: {
        id: orderBundle.id,
      },
    },
    redirect,
  }
}

export type BuildBundleOrderPayload = ReturnType<typeof buildBundleOrder>

export default buildBundleOrder
